<div class="delete-account-popup">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="text-center">Permanently delete your account?</h2>
      </div>
    </div>
    <form #deleteAccountFormDlg name="form" (ngSubmit)="onSubmit()" [formGroup]="deleteAccountForm" novalidate>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
          <div class="form-group" [ngClass]="{ 'ng-invalid': !deleteAccountForm.controls.confirmationText.valid }">
            <div class="text-center form-body">This action can't be undone.</div>
            <label for="confirmationText">Type "delete" to initiate account deletion:</label>
            <input #confirmationTextFld type="text" class="form-control" id="confirmationText" name="confirmationText" autocomplete="one-time-code"
            formControlName="confirmationText" (input)="onTextChange()"/>
            <div class="form-error valid-error" *ngIf="errorMessage">{{errorMessage}}</div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mg-top-24">
          <div class="form-group">
            <button type="submit"
              class="btn wb-btn-default center-block"
              [disabled]="(loading || disableDeleteAccountButton || !deleteAccountForm.valid)">
              Delete Account
            </button>
          </div>
        </div>
        <div class="text-center mg-top-24 mg-btm-9">
            <span role="button" (click)="childClosed()" class="btn wb-btn-outline">Cancel</span>
        </div>
      </div>
    </form>
  </div>
  